'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBaseball = function IoIosBaseball(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 3.8c8.9 0 16.2 7.2 16.2 16.2 0 0.6 0 1.3-0.1 1.9-0.9 8.1-7.8 14.4-16.1 14.4-9 0-16.3-7.3-16.3-16.3 0-8.4 6.3-15.2 14.4-16.2 0.6 0 1.2 0 1.9 0z m0.3 31.1c0.4 0 0.8 0 1.2-0.1-0.1-0.7-0.1-1.5-0.3-2.3l1.9-0.6-0.4-1.2-1.8 0.5c-0.3-1-0.7-2.1-1.3-3.2l1.6-1-0.7-1.1-1.5 1c-0.6-1-1.3-2-2.2-2.9l1.4-1.3-0.9-0.9-1.3 1.3c-0.9-0.8-1.8-1.5-2.8-2.2l1-1.4-1.1-0.7-1 1.5c-1.1-0.5-2.2-0.9-3.3-1.2l0.5-1.8-1.1-0.3-0.7 1.7c-0.8-0.1-1.6-0.2-2.4-0.3-0.1 0.4-0.1 0.9-0.1 1.3 0.7 0.1 1.4 0.1 2.1 0.2l-0.5 1.8 1.2 0.4 0.6-1.9c0.6 0.2 1.2 0.4 1.8 0.7 0.4 0.1 0.8 0.3 1.2 0.5l-1.1 1.6 1.1 0.7 1-1.7c1 0.6 1.9 1.2 2.7 2l-1.3 1.3 0.8 0.9 1.4-1.4c0.7 0.9 1.4 1.8 2 2.8l-1.6 1.1 0.7 1 1.5-1c0.2 0.4 0.3 0.7 0.5 1.1 0.2 0.6 0.5 1.2 0.6 1.8l-1.8 0.6 0.4 1.2 1.7-0.5c0.2 0.6 0.2 1.3 0.3 2z m11.8-13.4c0.8 0.1 1.8 0.3 2.6 0.4 0.1-0.4 0.1-0.9 0.1-1.3-0.8-0.1-1.6-0.1-2.4-0.3l0.5-1.5-1.2-0.4-0.5 1.6c-0.6-0.2-1.2-0.3-1.7-0.5-0.4-0.2-0.8-0.4-1.2-0.6l0.9-1.3-1-0.7-1 1.4c-0.9-0.6-1.8-1.2-2.6-2l1.1-1.1-0.9-1-1.2 1.2c-0.8-0.8-1.4-1.6-1.9-2.6l1.5-1-0.8-1-1.3 0.9c-0.2-0.4-0.4-0.8-0.6-1.2-0.2-0.6-0.4-1.1-0.6-1.7l1.7-0.5-0.4-1.2-1.6 0.5c-0.1-0.8-0.2-1.6-0.3-2.4-0.4 0-0.8 0-1.2 0 0.1 1 0.2 1.8 0.4 2.8l-2.1 0.6 0.4 1.2 2-0.6c0.3 1.1 0.7 2.2 1.2 3.2l-1.7 1.2 0.7 1 1.7-1.1c0.6 1 1.3 2 2.1 2.8l-1.5 1.5 0.8 0.9 1.5-1.5c0.9 0.8 1.9 1.6 2.9 2.2l-1.1 1.6 1 0.7 1.2-1.8c1 0.6 2.1 1 3.2 1.4l-0.6 1.9 1.2 0.4z' })
        )
    );
};

exports.default = IoIosBaseball;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-baseball.js
// module id = 2313
// module chunks = 0